import axiosInstance from '../axios/axiosInstance';
import { Book, Page } from '../model/response';
import { BookRequest } from '../model/request';
import { SortDirection } from '../model/enum';

export const getBookDetail = async (bookId: string) => {
  const { data } = await axiosInstance.get<Book>(`/books/${bookId}`);
  return data;
};

export const findAllBook = async (subjectId?: string | null) => {
  const { data } = await axiosInstance.get<Book[]>(`/books`, { params: { fromCMS: true, subjectId } });
  return data;
};

export const searchBook = async (
  size: number,
  page: number,
  sortBy: string | undefined,
  direction: SortDirection | undefined,
  keyword: string,
  subjectId: string | null,
  gradeId: string | null,
  testBankId: string | null,
) => {
  const { data } = await axiosInstance.get<Page<Book>>('/books/search', {
    params: {
      size,
      page,
      sortBy,
      direction,
      keyword,
      subjectId,
      gradeId,
      testBankId,
      fromCMS: true,
    },
  });
  return data;
};

export const createBook = async (request: BookRequest) => {
  await axiosInstance.post(`/books`, request);
};

export const editBook = async (id: string, request: BookRequest) => {
  await axiosInstance.put(`/books/${id}`, request);
};

export const toggleBookWebviewActive = async (id: string) => {
  await axiosInstance.patch(`books/${id}/toggle-web-view-active`);
};
